import { createSignal, JSX } from "solid-js";

import createPropsProvider from "@repo/utils-solid/createPropsProvider";

import Expand from "../animation/Expand";
import ContainerButton from "../buttons/ContainerButton";

declare namespace ShowMore {
  type Props = {
    children: JSX.Element;
    controller?: ReturnType<typeof ShowMore.controller>;
    text?(show: boolean): string;
    class?: string;
  };
}

ShowMore.controller = () => {
  const [show, setShow] = createSignal(false);
  return Object.assign(show, {
    toggle() {
      setShow(!show());
    },
  });
};

function ShowMore(props: D<ShowMore.Props>) {
  const {
    children,
    text = (show) => (show ? "Show less" : "Show more"),
    controller: showMore = ShowMore.controller(),
    class: className,
  } = ShowMore.PropsProvider.useMerge(props) satisfies D;

  return (
    <div>
      <Expand direction="y" show={showMore()}>
        {children}
      </Expand>
      <ContainerButton
        class={className}
        onClick={() => {
          showMore.toggle();
        }}
      >
        {text(showMore())} {showMore() ? "" : ""}
      </ContainerButton>
    </div>
  );
}

ShowMore.PropsProvider = createPropsProvider<ShowMore.Props>("ShowMore");

export default ShowMore;
